<template>
  <div>
    <el-form ref="formData" size="small" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_dict_value') || '业务字典编码'"
            prop="dictValue"
          >
            <el-input
              clearable
              v-model="formData.dictValue"
              :placeholder="
                $l('form_label_pe_dict_value') || '请输入业务字典编码'
              "
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_dict_text') || '业务字典中文显示文字'"
            prop="dictText"
          >
            <el-input
              clearable
              v-model="formData.dictText"
              :placeholder="
                $l('form_label_pe_dict_text') || '请输入业务字典中文显示文字'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row> </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_dict_text_en') || '业务字典英文显示文字'"
            prop="dictTextEn"
          >
            <el-input
              clearable
              v-model="formData.dictTextEn"
              :placeholder="
                $l('form_label_pe_dict_text_en') || '请输入业务字典英文显示文字'
              "
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_status') || '有效状态'"
            prop="dictStatus"
          >
            <br />
            <el-radio-group v-model="formData.dictStatus">
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="formData.dictType === 'attributeType'">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_is_second_level') || '二级属性'"
            prop="isSecondLevel"
          >
            <el-select v-model="formData.isSecondLevel" style="width:100%">
              <el-option label="是" value="Y"> </el-option>
              <el-option label="否" value="N"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_master_dict_value') || '所属一级属性'"
            prop="masterDictValue"
          >
            <dict-select
              filterable
              clearable
              v-model="formData.masterDictValue"
              url="/master/masterBizDictionary/selectAttributeType"
              :placeholder="
                $l('form_label_pe_master_dict_value') || '请选择所属一级属性'
              "
              :disabled="formData.isSecondLevel === 'N'"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_is_cost_packing') || '可进入成本(选择性勾选)'
            "
            prop="isCostPacking"
          >
            <el-checkbox
              v-model="formData.isCostPacking"
              true-label="Y"
              false-label="N"
            >
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_is_common') || '通用属性(选择性勾选)'"
            prop="isCommon"
          >
            <el-checkbox
              v-model="formData.isCommon"
              true-label="Y"
              false-label="N"
            >
            </el-checkbox>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  props: {
    keyID: String,
    dictType: String,
    dictDescription: String
  },
  components: {},
  data() {
    return {
      formData: {
        dictStatus: 'Y',
        isSecondLevel: 'N',
        isCostPacking: 'N',
        isCommon: 'N',
        dictType: this.dictType,
        dictDescription: this.dictDescription
      },
      rules: {
        dictValue: [
          {
            required: true,
            message:
              this.$l('form_label_pe_dict_value') || '请输入业务字典编码',
            trigger: 'blur'
          }
        ],
        dictText: [
          {
            required: true,
            message: this.$l('form_label_pe_dict_text') || '请输入中文显示文字',
            trigger: 'blur'
          }
        ],
        dictTextEn: [
          {
            required: true,
            message:
              this.$l('form_label_pe_dict_text_en') || '请输入英文显示文字',
            trigger: 'blur'
          }
        ],
        dictStatus: [
          { required: true, message: '请选择有效状态', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.getDate()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getDate() {
      if (!this.keyID) return
      this.$api
        .masterBizDictOptionsDetailApi({
          keyID: this.keyID
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .masterBizDictOptionsSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
